import axios from 'axios';
import { authInterceptor } from './auth';

const apiUrl = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8080';

const api = axios.create({
  baseURL: apiUrl + '/api',
  withCredentials: true, // penting supaya cookie dikirim otomatis ke server
});

api.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

// Keycloak SSO bearer token — runs after local token interceptor;
// only attaches KC token when no local session token is present.
api.interceptors.request.use(authInterceptor);

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config || {};

    // Do not attempt refresh for auth endpoints (signin/refresh/forgot/reset)
    const url = originalConfig.url || '';
    const isAuthEndpoint =
      url.includes('/auth/signin') ||
      url.includes('/auth/refresh-token') ||
      url.includes('/auth/forgot-password') ||
      url.includes('/auth/reset-password');

    if (err.response?.status === 401 && !originalConfig._retry && !isAuthEndpoint) {
      originalConfig._retry = true;

      try {
        // Kirim POST refresh-token tanpa body, cookie HttpOnly sudah otomatis dikirim
        const res = await axios.post(`${apiUrl}/api/auth/refresh-token`, null, {
          withCredentials: true,
        });

        const user = JSON.parse(localStorage.getItem('user'));
        const newUser = { ...user, token: res.data.accessToken };
        localStorage.setItem('user', JSON.stringify(newUser));

        api.defaults.headers.common['Authorization'] = `Bearer ${res.data.accessToken}`;
        originalConfig.headers['Authorization'] = `Bearer ${res.data.accessToken}`;

        return api(originalConfig);
      } catch (refreshErr) {
        // Do not hard reload; let the app handle auth state gracefully
        localStorage.removeItem('user');
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(err);
  }
);

export default api;
